import React, { Component } from 'react';
import { connect } from "react-redux";
import { Row, Col, Button, Modal, ModalHeader, ModalFooter, Card, CardBody, CardHeader } from "reactstrap";
import { NotificationManager } from "react-notifications";
import LoadingSpinner from "../../components/LoadingSpinner/index";
import DataTable from "../../components/Table/Table";
import "react-table/react-table.css";
import { Link } from "react-router-dom";
import { getDnsProviderConfigs, deleteDnsProviderConfig } from "../../actions/actionDnsProvider";

class DnsProviderConfig extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            filterId: null
        };

        this.cancelDelete = this.cancelDelete.bind(this);
        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.deleteDnsProviderAction = this.deleteDnsProviderAction.bind(this);
        this.handleDeleteSuccess = this.handleDeleteSuccess.bind(this);
        this.handleDeleteError = this.handleDeleteError.bind(this);
    }

    componentDidMount() {
        this.props.getDnsProviderConfigs();
    }

    deleteConfirm(DnsProviderConfigId, DnsProviderConfigName) {
        this.setState({
            modal: !this.state.modal,
            DnsProviderConfigId: DnsProviderConfigId,
            DnsProviderConfigName: DnsProviderConfigName
        });
    }

    cancelDelete() {
        this.setState({ modal: !this.state.modal });
    }

    deleteDnsProviderAction() {
        this.props.deleteDnsProviderConfig(this.state.DnsProviderConfigId, this.state.DnsProviderConfigName).
            then(() => this.handleDeleteSuccess()).
            catch(() => this.handleDeleteError());
    }

    handleDeleteSuccess() {
        const { deleteDnsProviderError } = this.props;
        if (deleteDnsProviderError) {
            NotificationManager.error(deleteDnsProviderError, "Delete DNS Provider Config Failed", 3000);
        } else {
            NotificationManager.success("Successfully Deleted DNS Provider Config", "Delete DNS Provider Config", 3000);
            this.setState({ modal: false });
            this.props.getDnsProviderConfigs();
        }
    }

    handleDeleteError() {
        const { deleteDnsProviderError } = this.props;
        if (deleteDnsProviderError) {
            NotificationManager.error(deleteDnsProviderError, "Failed to Delete DNS Provider Config", 3000);
            this.props.history.push("/dns_provider");
        } else {
            NotificationManager.error("Failed to Delete DNS Provider Config", "Delete DNS Provider Config", 3000);
            this.props.history.push("/dns_provider");
        }
    }

    render() {
        if (this.props.getDnsProviderLoading) {
            return (<div> <LoadingSpinner /></div>);
        }

        const { dns_provider_configs } = this.props;

        const tableColumns = [
            {
                type: "text",
                name: "Name",
                accessor: "dns_provider_config_name",
                filterable: true,
                sortable: true,
            },
            {
                type: "text",
                name: "Provider",
                accessor: "dns_provider_display_name",
                filterable: true,
                sortable: true,
            },
        ];

        const actions = [
            { id: "view", icon: "fa-eye", description: "View" },
            { id: "edit", icon: "fa-pencil", description: "Edit" },
            { id: "delete", icon: "fa-trash", description: "Delete" },
        ];

        const onAction = (action, item) => {
            switch (action) {
                case "view":
                    this.props.history.push(`/view_dns_provider/${item.dns_provider_config_id}`);
                    break;

                case "edit":
                    this.props.history.push(`/update_dns_provider/${item.dns_provider_config_id}`);
                    break;

                case "delete":
                    this.deleteConfirm(item.dns_provider_config_id, item.dns_provider_name);
                    break;
            }
        }

        return (
            <div className="profile-page">
                <Row>
                    <Col sm={{ size: 10, order: 3, offset: 1 }}>
                        <Card >
                            <CardHeader>
                                <div className="title-head">
                                    <i className="fa fa-book"></i> <strong>DNS Provider Configurations</strong></div>
                                <Link className="pull-right add-btn" to={{ pathname: "/create_dns_provider" }}>
                                    <button className="pull-right adduser-btn" size="sm" color="dark">
                                        <i className="fa fa-plus" aria-hidden="true"></i>
                                        Add
                                    </button>
                                </Link>
                            </CardHeader>
                            <CardBody className="p-0">
                                <DataTable
                                    id="dns_provider"
                                    data={dns_provider_configs}
                                    columns={tableColumns}
                                    actions={actions}
                                    onAction={onAction}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Modal isOpen={this.state.modal} toggle={this.cancelDelete} centered={true} className="user-modal">
                    <ModalHeader toggle={this.cancelDelete}>Are you sure you want to delete this config?
                    </ModalHeader>
                    <ModalFooter>
                        <Button onClick={this.cancelDelete} size="sm"
                            className="cancel-button"
                            color=" basic">Close</Button>
                        <Button onClick={this.deleteDnsProviderAction}
                            className="delete-button"
                            size="sm" color="danger">Delete</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

}

export default connect(state => ({
    dns_provider_configs: state.dns_provider.dns_provider_configs || [],
    getDnsProviderLoading: state.dns_provider.getDnsProviderLoading || false,
    getDnsProviderErrorMessage: state.dns_provider.getDnsProviderErrorMessage || false,
    getDnsProviderError: state.dns_provider.getDnsProviderError || null,
    deleteDnsProviderError: state.dns_provider.deleteDnsProviderError || null,
    deletedDnsProvider: state.dns_provider.deletedDnsProvider || null,
    deleteDnsProviderLoading: state.dns_provider.deletDnsProviderLoading || null,
    pages: { pageSize: state.dns_provider.pageSize, pageNo: state.dns_provider.pageNo },
}),
    dispatch => ({
        getDnsProviderConfigs: () => dispatch(getDnsProviderConfigs()),
        deleteDnsProviderConfig: (dns_provider_config_id, dns_provider_name) => dispatch(deleteDnsProviderConfig(dns_provider_config_id, dns_provider_name)),
        setPageInfo: (data) => dispatch(setProviderPageInfo(data)),
    }))(DnsProviderConfig);
